import React, { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

let globalLogout = () => {}; // placeholder


export function getToken() {
  return localStorage.getItem("jwt");
}

export const AuthProvider = ({ children }) => {
  const [jwt, setJwt] = useState(localStorage.getItem("jwt") || "");
  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("user") || "null")
  );


const login = (token, userData) => {
  setJwt(token);
  setUser(userData);

  localStorage.setItem("jwt", token);
  localStorage.setItem("user", JSON.stringify(userData));
};


  const logout = () => {
    setJwt(null);
    setUser(null);
    localStorage.removeItem("jwt");
    localStorage.removeItem("user");
  };

  globalLogout = logout;


  const isAuthenticated = !!jwt;

  return (
    <AuthContext.Provider value={{ jwt, user, login, logout, isAuthenticated }}>
      {children}
    </AuthContext.Provider>
  );
};
export function forceLogout() {
  globalLogout();
}